<div class="sidebar">
    <div class="sidebar-content border-right">
        <ng-container *ngFor="let group of groups">
            <div class="group nav-pills">
                <p>{{group.title}}</p>
                <ng-container *ngFor="let entry of group.entries">
                    <a class="nav-link" [ngClass]="router.url === entry.url ? 'active' : ''" [routerLink]="entry.url">
                        <fa-icon [icon]="entry.icon"></fa-icon>
                        {{entry.title}}
                        <div class="flex-spacer"></div>
                        <ng-container *ngIf="entry.accessory?.apply() != null && entry.accessory?.apply() > 0">
                            <span class="badge badge-warning">{{entry.accessory?.apply()}}</span>
                        </ng-container>
                    </a>
                </ng-container>
            </div>
        </ng-container>
    </div>
</div>
